import { _ as r } from "./index952.mjs";
import { _ as i } from "./index953.mjs";
var v = r, s = i;
function o(a, t) {
  var e = s(a, t);
  return v(e) ? e : void 0;
}
var n = o;
export {
  n as _
};
